<template>
  <div class="openAccountForm">
    <div class="info-center">
      <div class="kyc-icon"></div>
      <div class="wordW20" style="margin:16px 0 40px; text-align: center;">
        请设置账户交易密码
      </div>
      <div class="password-fir">
        <lls-form
          :model="ruleForm"
          class="demo-ruleForm"
          hide-required-asterisk
          ref="ruleForm"
          :rules="ruleFormRules"
        >
          <lls-form-item label="交易密码" prop="passwordFir" ref="passwordFir">
            <lls-popover
              v-model="visible"
              placement="right"
              width="300"
              trigger="focus"
            >
              <div class="pop-title">密码必须包含：</div>
              <div class="four-li">
                <div class="password-li">
                  <div class="green-hook-icon" v-if="firRegShow"></div>
                  <div class="grey-hook-icon" v-else></div>
                  <div
                    class="password-word"
                    :class="firRegShow ? 'word-green' : ''"
                  >
                    长度至少 8 个字符
                  </div>
                </div>
                <div class="password-li">
                  <div class="green-hook-icon" v-if="thiRegShow"></div>
                  <div class="grey-hook-icon" v-else></div>
                  <div
                    class="password-word"
                    :class="thiRegShow ? 'word-green' : ''"
                  >
                    1 个大写字母
                  </div>
                </div>
                <div class="password-li">
                  <div class="green-hook-icon" v-if="secRegShow"></div>
                  <div class="grey-hook-icon" v-else></div>
                  <div
                    class="password-word"
                    :class="secRegShow ? 'word-green' : ''"
                  >
                    1 个小写字母
                  </div>
                </div>
                <div class="password-li">
                  <div class="green-hook-icon" v-if="fouRegShow"></div>
                  <div class="grey-hook-icon" v-else></div>
                  <div
                    class="password-word"
                    :class="fouRegShow ? 'word-green' : ''"
                  >
                    1 个数字或符号
                  </div>
                </div>
              </div>
              <div class="pop-line"></div>
              <div class="pop-warning">
                <div class="warning-icon"></div>
                <div class="warning-word">
                  为了提升安全性，请避免使用其他网站的密码。
                </div>
              </div>
              <lls-input
                slot="reference"
                show-password
                v-model.trim="ruleForm.passwordFir"
                @input="checkPassword"
                autocomplete="off"
                placeholder="请输入"
              ></lls-input>
            </lls-popover>
          </lls-form-item>
          <lls-form-item label="确认密码" prop="passwordSec" ref="passwordSec">
            <lls-input
              show-password
              v-model.trim="ruleForm.passwordSec"
              autocomplete="off"
              placeholder="请输入"
            ></lls-input>
          </lls-form-item>
        </lls-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "transacPassword",
  data() {
    var validatePass1 = (rule, value, callback) => {
      console.log(value);
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.passwordFir) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      checkedAuth: false,
      visible: false,
      firRegShow: false,
      secRegShow: false,
      thiRegShow: false,
      fouRegShow: false,
      enterpriseId: sessionStorage.getItem("enterpriseId"),
      mediaId: sessionStorage.getItem("enterpriseId"),
      ruleForm: {
        passwordFir: sessionStorage.getItem("transPassword") || '',
        passwordSec: sessionStorage.getItem("transPassword") || '',
      },
      ruleFormRules: {
        passwordFir: [
          { required: true, message: "请输入新密码", trigger: "blur" },
        ],
        passwordSec: [{ validator: validatePass1, trigger: "blur" }],
      },
    };
  },
  methods: {
    checkPassword(num) {
      // num = num.replace();
      var firReg = new RegExp(".{8,}");
      var secReg = new RegExp("(?=.*?[a-z])");
      var thiReg = new RegExp("(?=.*?[A-Z])");
      var fouReg = new RegExp("(?=.*?[0-9])|(?=.*?[#?!@$%^&*-])");
      if (firReg.test(num)) {
        this.firRegShow = true;
      } else {
        this.firRegShow = false;
      }
      if (secReg.test(num)) {
        this.secRegShow = true;
      } else {
        this.secRegShow = false;
      }
      if (thiReg.test(num)) {
        this.thiRegShow = true;
      } else {
        this.thiRegShow = false;
      }
      if (fouReg.test(num)) {
        this.fouRegShow = true;
      } else {
        this.fouRegShow = false;
      }
    },
    nextSon() {
        if(this.ruleForm.passwordSec === this.ruleForm.passwordFir){
            sessionStorage.setItem('transPassword',this.ruleForm.passwordSec);
            this.$emit("toNext");
        }            
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../kycCommon.scss";
.openAccountForm {
  width: 100%;
  height: 100%;
  white-space: normal;
  .info-center {
    width: 720px;
    margin: 0 auto;
    .kyc-icon {
      width: 44px;
      height: 44px;
      background: url("~@/static/kjaccSonImg/kycIcon.png") center center
        no-repeat;
      margin: 0 auto;
    }
    .password-fir {
      width: 320px;
      margin: 0 auto;
    }
  }
}
.pop-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 9px;
}
.four-li {
  display: flex;
  flex-wrap: wrap;
  .password-li {
    display: flex;
    justify-content: flex-start;
    width: 125px;
    align-items: center;
    margin-right: 15px;
    margin-bottom: 8px;
    .grey-hook-icon {
      width: 14px;
      height: 14px;
      background: url("~@/static/kjaccSonImg/greyHook.svg") center center
        no-repeat;
    }
    .green-hook-icon {
      width: 14px;
      height: 14px;
      background: url("~@/static/kjaccSonImg/greenHook.svg") center center
        no-repeat;
    }
    .password-word {
      font-size: 12px;
      margin-left: 8px;
    }
    .word-green {
      color: #07a36f;
    }
  }
}
.pop-line {
  height: 1px;
  width: 100%;
  background-color: #ebf3ff;
  margin: 6px 0px;
}
.pop-warning {
  display: flex;
  justify-content: flex-start;
  line-height: 20px;
  align-items: center;
  .warning-icon {
    width: 14px;
    height: 14px;
    background: url("~@/static/kjaccSonImg/tipsOne.svg") center center no-repeat;
  }
  .warning-word {
    font-size: 12px;
    margin-left: 9px;
  }
}
</style>
